import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Updates from './components/Updates';
import TopicIndex from './components/TopicIndex';
import About from './components/About';
import Topics from './components/Topics';
import Carousel from './components/Carousel';
import Contact from './components/Contact';
import Media from './components/Media';
import Ranking from './components/Ranking';
import AppDownload from './components/AppDownload';
import Cards from './components/Cards';
import Comments from './components/Comments';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Updates />
        <TopicIndex />
        <About />
        <Topics />
        <Carousel />
        <Contact />
        <Media />
        <Ranking />
        <AppDownload />
        <Cards />
        <Comments />
        <Faq />
      </main>
      <Footer />
    </>
  );
}